import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {greys} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"
import {BOOKMARK_TYPE} from "../../../utils/constants/comment"
import {Para} from "../../../ui/Labels"


const Wrapper = styled(Para)`
  background-color: ${greys.light};
  padding: 5px 10px;
  border-radius: ${padding.tiny};
  text-align: left;
  text-transform: uppercase;
  font-size: 10px;
  display: inline-flex;
`

const BookmarkRenderer = ({tags}) => {
  const bookmark = tags.find((tag) => tag.type === BOOKMARK_TYPE)
  if (!bookmark) return null
  const {data: {note}} = bookmark
  return (
    <Wrapper> {note} </Wrapper>
  )
}

BookmarkRenderer.propTypes = {
  tags: PropTypes.array
}

BookmarkRenderer.defaultProps = {
  tags: []
}

export default BookmarkRenderer
